import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { ShiftsAreaRoutes } from '@backoffice-frontend/shifts-api'
import { CalendarScheduleClockIcon } from '@moia-dev/pace-icons'
import { ShiftsAreaDataTestIds } from './ShiftsAreaDataTestIds'

export const ShiftsAreaNavigationIcon = CalendarScheduleClockIcon

export const ShiftsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={ShiftsAreaRoutes.route}
      Icon={CalendarScheduleClockIcon}
      dataTestId={ShiftsAreaDataTestIds.Navigation}
    />
  )
}
